<template>
  <div class="service-visit-page">
    <KTCard ref="preview" v-bind:title="'Add new'">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-service-locations' }">{{
            $t("MENU.ITEM.SERVICE.LOCATIONS")
          }}</router-link>
          <i class="mr-2"></i>
          <small>{{ $t("LABELS.ADD_NEW") }}</small>
        </h3>
      </template>
      <template v-slot:toolbar>
        <div class="service-visit-page__actions">
          <BackButton />
          <SaveButton :isLoading="isLoadingServiceLocation" @save="onSave" />
        </div>
      </template>
      <template v-slot:body>
        <b-form>
          <ServiceLocationsForm ref="ServiceLocationsForm" :form="form" />
          <v-overlay :value="isLoadingServiceLocation">
            <v-progress-circular indeterminate size="64" />
          </v-overlay>
        </b-form>
      </template>
      <template v-slot:foot>
        <div v-show="_.size(errors) > 0" role="alert" class="alert alert-danger">
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error[0] }}
          </div>
        </div>
      </template>
      <template v-slot:toolbarfoot>
        <div class="service-visit-page__actions">
          <BackButton />
          <SaveButton :isLoading="isLoadingServiceLocation" @save="onSave" />
        </div>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SAVE_SERVICE_LOCATION } from "@/modules/service-locations/store/service-locations.module";
import { mapGetters } from "vuex";
import KTCard from "@/view/content/Card.vue";
import SaveButton from "@/view/content/forms/components/SaveButton.vue";
import ServiceLocationsForm from "../components/ServiceLocationsForm.vue";

export default {
  name: "ServiceLocationsAdd",
  components: {
    KTCard,
    SaveButton,
    ServiceLocationsForm
  },
  data() {
    return {
      errors: {},
      form: {
        serviceLocationTypeId: null,
        name: null,
        location: null
      }
    };
  },
  computed: {
    ...mapGetters(["isLoadingServiceLocation"])
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("MENU.ITEM.SERVICE.LOCATIONS"),
        route: { name: "list-service-locations" }
      },
      { title: this.$i18n.t("LABELS.ADD_NEW") }
    ]);
  },
  methods: {
    onSave() {
      const formComponent = this.$refs.ServiceLocationsForm;
      formComponent.$v.form.$touch();
      if (formComponent.$v.form.$anyError) {
        this.$notify({
          group: "notify",
          type: "error",
          title: this.$t("ALERTS.ERROR"),
          text: "Please fill all required fields correctly"
        });
        return;
      }

      this.$store
        .dispatch(SAVE_SERVICE_LOCATION, this.form)
        .then(data => {
          this.errors = data.data.errors;
          this.$notify({
            group: "notify",
            type: "success",
            title: "<i class='flaticon2-checkmark'></i> Success",
            text: data.message
          });
          this.$router.push({ name: "list-service-locations" });
        })
        .catch(response => {
          this.errors = response.data.errors;
          this.$notify({
            group: "notify",
            type: "error",
            title: this.$t("ALERTS.ERROR"),
            text: response.data.message
          });
        });
    }
  }
};
</script>
